import { useState, useEffect } from 'react'
import styles from './index.module.less'
import EchoCard from '@/components/EchoCard'
import { Menu } from '@arco-design/web-react'
import { useData, useDetailData } from './DATA'
import { useRouter } from 'next/router'
import GuideDetail from './guide-detail'
import useLocale from '@/utils/useLocale'
import { wrapper } from '@/store'
import { generateSsrCtx } from '@/api/request'
import getServerSidePropsCatch from '@/utils/getServerSidePropsCatch'

const MenuItem = Menu.Item
const SubMenu = Menu.SubMenu

const Guide = () => {
  const t = useLocale()
  const [selectedKeys, setSelectedKeys] = useState<string[]>(['products'])
  const details = useDetailData()
  const dataList = useData()
  const router = useRouter()
  const currentId = router.query.id
  const currentData = currentId ? details.find((i) => i.path === currentId) : {}

  useEffect(() => {
    if (router.query.id) {
      setSelectedKeys([router.query.id as string])
    }
  }, [router.query.id])

  return (
    <div>
      <div className={styles.title}>{t['product_guide']}</div>
      <div className={styles.subtitle}>{t['echotik_guide']}</div>
      <EchoCard>
        <div className={styles.content}>
          <div className={styles.nav} style={{ height: 700 }}>
            <Menu
              hasCollapseButton={false}
              autoOpen
              selectedKeys={selectedKeys}
              style={{ height: '100%' }}
              defaultOpenKeys={['0']}
              defaultSelectedKeys={selectedKeys}
              onClickMenuItem={(key: string, event, keyPath: string[]) => {
                router.push(`/guide/${key}`)
                setSelectedKeys([key])
              }}
            >
              {dataList.map((item, index) => {
                return (
                  <SubMenu key={`${index}`} title={item.title}>
                    {item?.children
                      ?.filter((i) => !i.hide)
                      .map((child, subIndex) => {
                        return <MenuItem key={child.path}>{child.title}</MenuItem>
                      })}
                  </SubMenu>
                )
              })}
            </Menu>
          </div>
          <div className={styles.component}>
            {router.pathname === '/guide' ? <p>{t['menu_left_guide']}</p> : <GuideDetail data={currentData} />}
          </div>
        </div>
      </EchoCard>
    </div>
  )
}

export const getServerSideProps = wrapper.getServerSideProps<any>((store) => async (context) => {
  try {
    const ssrCtx = generateSsrCtx(store.getState())

    return {
      props: {
        ssrCtx
      }
    }
  } catch (error) {
    return getServerSidePropsCatch(error)
  }
})
export default Guide
